import React from 'react'
import Fade from 'react-reveal/Fade'

export default function Map() {
    return (
        <Fade>
            <section className="container mb-5 d-flex align-items-center" style={{ height: '55vh', borderRadius: '15px' }}>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3962.0628841129083!2d107.05327837419043!3d-6.762187166123699!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69b31fd64be90b%3A0x2a53dc653fbb85d7!2sGreen%20Hill%20Resort!5e0!3m2!1sid!2sid!4v1738737208997!5m2!1sid!2sid"
                    style={{ border: 0, width: '100%', height: '100%', borderRadius: '15px' }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade">
                </iframe>
            </section>
        </Fade>
    )
}
